import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { useUser } from './hooks/useUser';
import NicknameEntry from './components/NicknameEntry';
import ChatRoom from './components/ChatRoom';
import './App.css';

function App() {
  const { user, setNickname, clearUser } = useUser();

  if (!user) {
    return (
      <LanguageProvider>
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      </LanguageProvider>
    );
  }

  return (
    <LanguageProvider>
      <div className="app-container">
        {!user.nickname ? (
          <NicknameEntry onJoin={setNickname} />
        ) : (
          <ChatRoom user={user} onLeave={clearUser} />
        )}
      </div>
    </LanguageProvider>
  );
}

export default App;